import React from 'react';
import FilterCollapsible from './ui/FilterCollapsible';
import { useSelector } from 'react-redux';

const FilterMenu = () => {
  const productFilters = useSelector((state) => state.productFiltering);

  // Filter out filters that have no options with quantity > 0
  const validFilters = productFilters.facetFilters.filter((filter) =>
    filter.options.some((option) => option.quantity > 0)
  );

  return (
    <div className="filter-menu">
      {!!validFilters.length &&
        validFilters.map((filter) => (
          <FilterCollapsible
            key={filter.id}
            title={filter.label}
            filter={filter}
          />
        ))}
    </div>
  );
};

export default FilterMenu;
